// eslint-disable
import { ErrorMessage, FieldArray } from "formik";
import { Button, Col, FormGroup, Input, Label, Row } from "reactstrap";
import {
  placeholderNoOptions,
  placeholderSelectSimple,
  placeholderText,
} from "../../../../shared/helpers/placeHolders";
import { IAcademicEducation } from "../../../../shared/model/academic-education.model";
import { newAcademics } from "../../PostulateModel";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusSquare, faTrash } from "@fortawesome/free-solid-svg-icons";
import {
  validateAcademicsDegree,
  validateAcademicsEndDate,
  validateAcademicsStartDate,
  validateAcademicsStatus,
} from "../../../../shared/helpers/validateFields";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { educationalAttainmentEnum } from "../../../../shared/selectors/educationalAttainmentEnum";
import {
  to_ICountry,
  to_ISelect_Entity,
  to_ISelect_Entity_Array,
  to_ISelect_Enum,
} from "../../../../shared/mutator/dataTransformSelect";
import { connect } from "react-redux";
import { IRootState } from "../../../../reducers";
import { careerStatusEnum } from "../../../../shared/selectors/careerStatusEnum";
import { isDisabled } from "../../../../shared/helpers/isDisabledEndDate";
import { customStyles } from "../custom-selector-styles";

interface IProps extends StateProps, DispatchProps {
  formik: any;
  showErrorsInputs: boolean;
  setShowErrorsInputs: (data: boolean) => void;
}
const animatedComponents = makeAnimated();
export const AcademicEducation = (props: IProps) => {
  const { formik, formData, showErrorsInputs } = props;

  return (
    <>
      {/* Formacion academica */}
      <Row className="title-form">Formación académica</Row>
      <FieldArray
        name="academicEducations"
        render={(arrayHelpers) => (
          <div>
            {formik.values.academicEducations &&
              formik.values.academicEducations.map(
                (currentValue: IAcademicEducation, index: number) => (
                  <Row
                    className="mt-5 animate__animated animate__fadeIn container__form__postulate"
                    key={index}
                  >
                    {index > 0 && <hr></hr>}
                    <Col xs={12}>
                      <Row>
                        <Col className="d-flex justify-content-end">
                          <Button
                            className="btn-delete-item"
                            outline
                            onClick={() => {
                              arrayHelpers.remove(index);
                              props.setShowErrorsInputs(false);
                            }} // remove a field from the list
                          >
                            <span className="d-md-inline">
                              <FontAwesomeIcon icon={faTrash} />
                            </span>
                          </Button>
                        </Col>
                      </Row>

                      <Row className="container-inputs-form">
                        <Input
                          type="text"
                          hidden
                          name={`academicEducations[${index}].id`}
                          readOnly
                          value={currentValue.id || "0"}
                        ></Input>
                        <Col>
                          <FormGroup>
                            <Label
                              className={
                                validateAcademicsDegree(
                                  formik,
                                  index,
                                  showErrorsInputs
                                )
                                  ? "text-danger"
                                  : ""
                              }
                            >
                              Título*
                            </Label>
                            <Input
                              type="text"
                              name={`academicEducations[${index}].degree`}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur(
                                `academicEducations[${index}].degree`
                              )}
                              value={currentValue?.degree || ""}
                              className={
                                validateAcademicsDegree(
                                  formik,
                                  index,
                                  showErrorsInputs
                                )
                                  ? "is-invalid"
                                  : ""
                              }
                              placeholder={placeholderText()}
                            />
                            {validateAcademicsDegree(
                              formik,
                              index,
                              showErrorsInputs
                            ) && (
                              <div className="invalid-feedback">
                                {
                                  formik.errors?.academicEducations[index]
                                    .degree
                                }
                              </div>
                            )}
                          </FormGroup>
                        </Col>
                        <Col>
                          <FormGroup>
                            <Label>Nivel de estudio*</Label>
                            <Select
                              name={`academicEducations[${index}].educationalAttainment`}
                              placeholder={placeholderSelectSimple()}
                              noOptionsMessage={() => placeholderNoOptions()}
                              components={animatedComponents}
                              options={educationalAttainmentEnum()}
                              value={to_ISelect_Enum(
                                formik.values.academicEducations[index]
                                  .educationalAttainment,
                                educationalAttainmentEnum()
                              )}
                              onChange={(e: any) => {
                                formik.setFieldValue(
                                  `academicEducations[${index}].educationalAttainment`,
                                  e.value
                                );
                              }}
                              className={`select-postulate`}
                              onBlur={formik.handleBlur(
                                `academicEducations[${index}].educationalAttainment`
                              )}
                              styles={customStyles}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row className="container-inputs-form">
                        <Col md="6">
                          <FormGroup>
                            <Label>País en el que estudia/estudió</Label>
                            <Select
                              isClearable
                              name={`academicEducations[${index}].country`}
                              placeholder={placeholderSelectSimple()}
                              noOptionsMessage={() => placeholderNoOptions()}
                              components={animatedComponents}
                              options={
                                formData.countries
                                  ? to_ISelect_Entity_Array(formData.countries)
                                  : []
                              }
                              value={to_ISelect_Entity(
                                formik.values.academicEducations[index].country
                              )}
                              onChange={(e: any) => {
                                formik.setFieldValue(
                                  `academicEducations[${index}].country`,
                                  to_ICountry(e)
                                );
                              }}
                              onBlur={formik.handleBlur(
                                `academicEducations[${index}].country`
                              )}
                              className={`select-postulate`}
                              styles={customStyles}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row className="container-inputs-form">
                        <Col>
                          <FormGroup>
                            <Label
                              className={
                                validateAcademicsStartDate(formik, index)
                                  ? "text-danger"
                                  : ""
                              }
                            >
                              Fecha de inicio
                            </Label>
                            <Input
                              type="date"
                              name={`academicEducations[${index}].startDate`}
                              onChange={formik.handleChange(
                                `academicEducations[${index}].startDate`
                              )}
                              onBlur={formik.handleBlur(
                                `academicEducations[${index}].startDate`
                              )}
                              value={currentValue?.startDate || ""}
                              className={
                                validateAcademicsStartDate(formik, index)
                                  ? "is-invalid"
                                  : ""
                              }
                              placeholder={placeholderText()}
                            />
                            <div className="invalid-feedback">
                              <ErrorMessage
                                name={`academicEducations[${index}].startDate`}
                              />
                            </div>
                          </FormGroup>
                        </Col>
                        <Col>
                          <FormGroup>
                            <Label
                              className={
                                validateAcademicsEndDate(formik, index)
                                  ? "text-danger"
                                  : ""
                              }
                            >
                              Fecha de fin
                            </Label>
                            <Input
                              type="date"
                              name={`academicEducations[${index}].endDate`}
                              onChange={formik.handleChange(
                                `academicEducations[${index}].endDate`
                              )}
                              onBlur={formik.handleBlur(
                                `academicEducations[${index}].endDate`
                              )}
                              value={currentValue?.endDate || ""}
                              placeholder={placeholderText()}
                              disabled={isDisabled(
                                formik.values.academicEducations[index]
                                  .toPresent,
                                index
                              )}
                              className={
                                validateAcademicsEndDate(formik, index)
                                  ? "is-invalid"
                                  : ""
                              }
                            />
                            <div className="invalid-feedback">
                              <ErrorMessage
                                name={`academicEducations[${index}].endDate`}
                              />
                            </div>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row className="mt-3 justify-content-end">
                        <Col
                          md="6"
                          className="text-right d-flex justify-content-end"
                        >
                          <FormGroup className="form-check">
                            <Input
                              type="checkbox"
                              name={`academicEducations[${index}].toPresent`}
                              onChange={(e) => {
                                formik.setFieldValue(
                                  `academicEducations[${index}].toPresent`,
                                  e.target.checked
                                );
                                if (e.target.checked) {
                                  formik.setFieldValue(
                                    `academicEducations[${index}].endDate`,
                                    null
                                  );
                                }
                              }}
                              onBlur={formik.handleBlur(
                                `academicEducations[${index}].toPresent`
                              )}
                              checked={
                                formik.values.academicEducations[index]
                                  ?.toPresent || false
                              }
                              className="form-check-input"
                            />
                            <label className="form-check-label pt-0 ml-3">
                              Actualmente
                            </label>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row className="container-inputs-form">
                        <Col md="6">
                          <FormGroup>
                            <Label
                              className={
                                validateAcademicsStatus(formik, index)
                                  ? "text-danger"
                                  : ""
                              }
                            >
                              Estado de carrera*
                            </Label>
                            <Select
                              name={`academicEducations[${index}].careerStatus`}
                              placeholder={placeholderSelectSimple()}
                              noOptionsMessage={() => placeholderNoOptions()}
                              components={animatedComponents}
                              // options={to_ISelect_Array(countries)}
                              options={careerStatusEnum()}
                              value={to_ISelect_Enum(
                                formik.values.academicEducations[index]
                                  .careerStatus,
                                careerStatusEnum()
                              )}
                              onChange={(e: any) => {
                                formik.setFieldValue(
                                  `academicEducations[${index}].careerStatus`,
                                  e.value
                                );
                              }}
                              onBlur={formik.handleBlur(
                                `academicEducations[${index}].careerStatus`
                              )}
                              className={`select-postulate ${
                                validateAcademicsStatus(formik, index)
                                  ? "is-invalid"
                                  : ""
                              }`}
                              styles={customStyles}
                            />
                            {validateAcademicsStatus(formik, index) && (
                              <div className="invalid-feedback">
                                <ErrorMessage
                                  name={`academicEducations[${index}].careerStatus`}
                                />
                              </div>
                            )}
                          </FormGroup>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                )
              )}
            <Row>
              <Col className="d-flex justify-content-end align-items-end">
                <Button
                  className={`${
                    formik.values.academicEducations &&
                    formik.values.academicEducations.length > 0
                      ? "btn-link"
                      : "btn-link-card"
                  }`}
                  outline
                  onClick={() => arrayHelpers.push(newAcademics)}
                >
                  {formik.values.academicEducations &&
                  formik.values.academicEducations.length > 0 ? (
                    <>
                      <span>
                        <FontAwesomeIcon icon={faPlusSquare} />
                      </span>
                      Agregar formación
                    </>
                  ) : (
                    "Agregar formación académica"
                  )}
                </Button>
              </Col>
            </Row>
            {formik.values.academicEducations &&
              formik.values.academicEducations.length > 0 && <hr></hr>}
          </div>
        )}
      />
    </>
  );
};
const mapStateToProps = (state: IRootState) => {
  return {
    formData: state.postulateReducer.entities,
    loading: state.postulateReducer.loading,
  };
};
const mapDispatchToProps = {};
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(AcademicEducation);
